import { Box, Typography } from "@mui/material";
import { colors } from "../../Style";
import { Translate } from "react-i18nify";

export const BatteryPopUp = (props) => {
  return (
    <Box
      sx={{
        p: 2,
        width: "350px",
        height: "150px",
        background: "black",
        border: "1px solid white",
        display: props.state.visible ? "flex" : "none",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
      }}
    >
      <Box sx={{ height: "50%", alignContent: "center" }}>
        <Typography
          sx={{ color: colors().SPO2, fontWeight: "bold", fontSize: "30px", }}
          variant="h5"
          align="center"
        >
          <Translate value="BatteryMode" />
        </Typography>
      </Box>

      <Box sx={{ height: "50%",}}>
        <Typography
          sx={{
            color: colors().COLORS_ALARM_HIGH,
            fontWeight: "bold",
            fontSize: "30px",
          }}
          variant="h5"
          align="center"
        >
          <Translate value="ConnectToPower" />
        </Typography>
      </Box>
      <Box sx={{ height: "50%",}}>
        {props.state.alarm?.alarmCode == 241 || props.state.alarm?.alarmCode == 340 ? (
          <Typography
            sx={{ color: colors().COLORS_ALARM_HIGH, fontWeight: "bold", fontSize: "25px" }}
            variant="h5"
            align="center"
          >
            Critically Low Battery
          </Typography>
        ) : null}

      </Box>
    </Box>
  );
};
